import { render } from "./SeamlessVideoPageComponent.vue?vue&type=template&id=b92c9908"
import script from "./SeamlessVideoPageComponent.vue?vue&type=script&lang=js"
export * from "./SeamlessVideoPageComponent.vue?vue&type=script&lang=js"

import "./SeamlessVideoPageComponent.vue?vue&type=style&index=0&id=b92c9908&lang=css"

import exportComponent from "C:\\Users\\Aleix\\Feina\\PurpleTGames\\External\\Dreamtech5\\dreamtech-hyperbaric\\hiperbaric\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__